import {$, w} from './constants';

w.load(() => {

   
    if(localStorage.getItem('artempo_cookie')){
        $('#cookie-artempo').addClass('hide-cookies');
    }else{
        $('#cookie-artempo').delay(1500).fadeIn(500);
        $('#button-cookie').click(() => {
            localStorage.setItem('artempo_cookie', 'true');
            $('#cookie-artempo').addClass('hide-cookies');
            console.log('Acepto cookies')
        })
    }
});